/***** DESKTOP *******/
(function ($) {


    // setup header affix

    var $header = $('header');

    $header.append('<div class="ph-header-affix"></div>');

    $('.ph-header-affix').height($header.height());

    $header.affix({
        offset: {
            top: function () {
                return this.top = $header.offset().top;
            }
        }
    })    


    // setup testimonials carousel

    var cells = [];


    var $sectionToProcess = $('.page-section:eq(0)');

    while ($sectionToProcess.length == 1) {

        if (isEligibleCell($sectionToProcess)) {
            cells.push($sectionToProcess);
        } else {
            if (cells.length > 1) {
                buildCarousel(cells);
            }

            cells = [];
        }

        $sectionToProcess = $sectionToProcess.next();
    }

    if (cells.length > 1) {
        buildCarousel(cells);
    }

    function isEligibleCell($elem) {

        if (!$elem.hasClass('page-section'))
            return false;

        var $testimonialWidget = $('.widget-testimonial', $($elem));
        if ($testimonialWidget.length != 1)
            return false;

        return $testimonialWidget.siblings().length == 0;
    }

    //buildCarousel(cells);

    function buildCarousel($elemnts) {

        var carouselCells = $($elemnts);// $($elemnts).wrap('<div class="carousel-cell"></div>');

        var time = new Date().getTime();

        var cellClass = 'cell-' + time;
        var carouselClass = 'carousel-' + time;

        var maxHeight = 0;

        carouselCells.each(function () {
            $(this).addClass(cellClass + ' carousel-cell');
            var cellHeight = $(this).find('.widget-testimonial').height();

            maxHeight = Math.max(maxHeight, cellHeight);
        });


        carouselCells.each(function () {

            $(this).find('.widget-testimonial').height(maxHeight + 'px');

        });
        //console.log('carouselCells', carouselCells);

        $('.' + cellClass).wrapAll('<div class="carousel  carousel-testimonials ' + carouselClass + '"></div>')[0];

        //console.log('carousel', carouselEl);

        $('.' + carouselClass).flickity({
            // options
            cellAlign: 'left',
            contain: true
        });

    }


    // back to top affix
    $('.back-to-top-wrap').affix({
        offset: {
            top: 300
        }
    })



    $('#scrollToTop').click(function () {

        //console.log('back-to-top-wrap');

        jQuery('html,body').animate({
            scrollTop: 0
        }, "fast");
    });


    // scrolltojumplink
    function jumpToUrlAnchor() {

        if ((window.location.hash || '').length > 1) {
            var anchorName = window.location.hash.substring(1);

            if (anchorName.indexOf('=') > -1)
                return;

            scrollToAnchor(anchorName);
        }
    }

    function scrollToAnchor(anchorName) {
        console.log('scrollToAnchor =', anchorName);
        var jumpTarget = $('[data-jumplink-title="' + anchorName + '"]');

        if (jumpTarget.length > 0) {
            jQuery('html,body').animate({
                scrollTop: (Math.floor(jumpTarget.offset().top) - 60) + 'px'
            }, "fast");
        }
    }

    setTimeout(function () { jumpToUrlAnchor(); }, 200);

    // jumplinks

    //console.log('jumplink click setup');

    setTimeout(function () {

        $('.jumplink').click(function (e) {

            // console.log('jumplink clicked: ');
            e.preventDefault();
            e.stopPropagation();

            // console.log('targeting: ' + $(this).attr('href'));
            var $target = $($(this).attr('href'));

            var isMobile = $(window).width() < 1200;

            var scrollTop = Math.floor($target.offset().top) - (isMobile ? 0 : 60);

            if ($(this).closest('#mobileNav').length > 0) {
                $('#top-header-navbar button.navbar-toggler').click();
            }

            if ($target.length > 0) {
                jQuery('html,body').animate({
                    scrollTop: scrollTop + 'px'
                }, "fast");
            }
        })

    }, 300);

    $('.next-section-jumplink').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $parentSection = $(this).closest('.page-section');

        var $target = $parentSection.next('[data-jumplink-title]');
        if ($target.length > 0) {

            var isMobile = $(window).width() < 1200;

            var scrollTop = Math.floor($target.offset().top) - (isMobile ? 0 : 60);

            if ($target.length > 0) {
                jQuery('html,body').animate({
                    scrollTop: scrollTop + 'px'
                }, "fast");
            }
        }

    });
    
    // console.log('jumplink click setup done');

    // kpi inviewport logic

    $(".widget-kpi .counter").on('inviewport', function () {

        if (($(this).text() || '').length > 0) {

            var useFormat = $(this).attr('data-useformat') == '1';

            $(this).prop('Counter', 0).animate({
                Counter: $(this).text()
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    var value = Math.ceil(now);
                    $(this).text(useFormat
                        ? new Intl.NumberFormat('en-CA').format(value)
                        : value);
                }
            });
        }
    })

    $(".widget-kpi .counter").inviewport({
        threshold: 75
    })


    // stop playback on modal close
    $(".video-modal").on('hidden.bs.modal', function () {

        $(this).find('iframe').each(function () {
            var $this = $(this);
            $this.attr('src', $this.attr('src'));
        })
    });


})(jQuery);


